import { Dispatch } from "react"
import {FlowType} from "../../constants/flowType";
import {OrderInitial, PaymentCurrency} from "../../constants/types";
import {immediatePurchaseOrder} from "../../slices/OrderSlice";
import { getPaymentCallbacks } from "../../payment/helpers/buyBundleHandlers";
import urlApi from "shared/actions/urlApi";

interface ImmediatePurchase {
    currentCurrencyBalance?: any
    dispatch: Dispatch<any>
    order: Partial<OrderInitial>
    isGalleryModer?: boolean
    needAcquiring?: boolean
    productPrice?: PaymentCurrency
    error?: (message: string) => unknown
    profile?: any
    competitionId?: string
    selectedProjectId?: string
}

/**
 * запуск немедленной покупки
 */
export const runImmediatePurchase = async (props: ImmediatePurchase) => {
    const { dispatch, order, profile, competitionId, selectedProjectId } = props
    let usedOrder = order
    try {
        const purchaseOrder: any = { ...order?.immediatePurchaseProps }
        
        // Для COPY_CARD flow копируем карточку перед покупкой
        if (order?.immediatePurchaseProps?.flowType === FlowType.COPY_CARD) {
            const activeCard = purchaseOrder?.productInfo;
            if (activeCard?.id && profile?.accountId) {
                try {
                    const cardCopyId = await urlApi().copyCard({
                        cardId: activeCard.id,
                        userId: profile.accountId,
                        collectionId: activeCard.collectionId || profile.accountId
                    });
                    purchaseOrder.productId = cardCopyId;
                } catch (error) {
                    throw error;
                }
            } else {
                console.error('COPY_CARD - missing cardId or accountId:');
            }
        }
        
        if(order.activeTariff?.creatingPrice && [FlowType.BUY_BOOK].includes(order?.immediatePurchaseProps?.flowType as FlowType)) {
            const sequenceTariffType = order.activeTariff.type || 1
            purchaseOrder.tariff = {
                sequenceTariffType,
                creatingPrice: order.activeTariff.creatingPrice,
                userPrice: order.activeTariff.userPrice,
            }
        }

        // @ts-ignore
        if ([FlowType.BUY_BOOK, FlowType.COPY_BOOK].includes(order?.flowType)) {
            purchaseOrder.bookId = order?.immediatePurchaseProps?.bookId
        }

        if (props.needAcquiring) {
            const { checkoutUrlError, checkoutUrlSuccess } = getPaymentCallbacks({
                order: { ...purchaseOrder },
                competitionId: competitionId,
                selectedProjectId: selectedProjectId,
            })
            purchaseOrder.options = {
                ...purchaseOrder.options,
                checkoutUrlError,
                checkoutUrlSuccess,
            }
        }

        if (props.productPrice) {
            purchaseOrder.productPrice = props.productPrice
        }

        //@ts-ignore
        const immediatePurchaseRequest: any = await dispatch(immediatePurchaseOrder(purchaseOrder)).then(r=>r).catch((err: any) => {
            console.log('immediatePurchaseRequest err!!!', purchaseOrder, err)
        })

        const immediateOrder = immediatePurchaseRequest?.payload?.order
        if (immediateOrder?.id) {
            usedOrder = { ...usedOrder, orderId: immediateOrder?.id }
        }
    } catch (err: any) {
        console.error('runImmediatePurchase err:', err)
    }
    return {
        usedOrder,
    }
}import { Dispatch } from "react"
import {FlowType} from "../../constants/flowType";
import {OrderInitial, PaymentCurrency} from "../../constants/types";
import {immediatePurchaseOrder} from "../../slices/OrderSlice";
import { getPaymentCallbacks } from "../../payment/helpers/buyBundleHandlers";
import urlApi from "shared/actions/urlApi";

interface ImmediatePurchase {
    currentCurrencyBalance?: any
    dispatch: Dispatch<any>
    order: Partial<OrderInitial>
    isGalleryModer?: boolean
    needAcquiring?: boolean
    productPrice?: PaymentCurrency
    error?: (message: string) => unknown
    profile?: any
    competitionId?: string
    selectedProjectId?: string
}

/**
 * запуск немедленной покупки
 */
export const runImmediatePurchase = async (props: ImmediatePurchase) => {
    const { dispatch, order, profile, competitionId, selectedProjectId } = props
    let usedOrder = order
    try {
        const purchaseOrder: any = { ...order?.immediatePurchaseProps }
        
        // Для COPY_CARD flow копируем карточку перед покупкой
        if (order?.immediatePurchaseProps?.flowType === FlowType.COPY_CARD) {
            const activeCard = purchaseOrder?.productInfo;
            if (activeCard?.id && profile?.accountId) {
                try {
                    const cardCopyId = await urlApi().copyCard({
                        cardId: activeCard.id,
                        userId: profile.accountId,
                        collectionId: activeCard.collectionId || profile.accountId
                    });
                    purchaseOrder.productId = cardCopyId;
                } catch (error) {
                    throw error;
                }
            } else {
                console.error('COPY_CARD - missing cardId or accountId:');
            }
        }
        
        if(order.activeTariff?.creatingPrice && [FlowType.BUY_BOOK].includes(order?.immediatePurchaseProps?.flowType as FlowType)) {
            const sequenceTariffType = order.activeTariff.type || 1
            purchaseOrder.tariff = {
                sequenceTariffType,
                creatingPrice: order.activeTariff.creatingPrice,
                userPrice: order.activeTariff.userPrice,
            }
        }

        // @ts-ignore
        if ([FlowType.BUY_BOOK, FlowType.COPY_BOOK].includes(order?.flowType)) {
            purchaseOrder.bookId = order?.immediatePurchaseProps?.bookId
        }

        if (props.needAcquiring) {
            const { checkoutUrlError, checkoutUrlSuccess } = getPaymentCallbacks({
                order: { ...purchaseOrder },
                competitionId: competitionId,
                selectedProjectId: selectedProjectId,
            })
            purchaseOrder.options = {
                ...purchaseOrder.options,
                checkoutUrlError,
                checkoutUrlSuccess,
            }
        }

        if (props.productPrice) {
            purchaseOrder.productPrice = props.productPrice
        }

        //@ts-ignore
        const immediatePurchaseRequest: any = await dispatch(immediatePurchaseOrder(purchaseOrder)).then(r=>r).catch((err: any) => {
            console.log('immediatePurchaseRequest err!!!', purchaseOrder, err)
        })

        const immediateOrder = immediatePurchaseRequest?.payload?.order
        if (immediateOrder?.id) {
            usedOrder = { ...usedOrder, orderId: immediateOrder?.id }
        }
    } catch (err: any) {
        console.error('runImmediatePurchase err:', err)
    }
    return {
        usedOrder,
    }
}